import moment from "moment";
// import timeZone from "./timeZone";
import "moment/locale/fr";
moment.locale("fr");
// moment.utc(timeZone);
export default moment;
